import { createContext } from "react";
import { MobileAppSubscribe, OS } from "../types";

export const MobileAppContext = createContext<null | {
  subscribe: MobileAppSubscribe;
  isApp: boolean;
  appVersion: null | string;
  appOS: null | OS;
  patchVersion: null | string;
}>(null);
